import { useMemo } from 'react';
import {
  Equipment,
  InstanceData,
  ServiceInsightDetailProps
} from 'services/equipment/types';
import { SERVICE_ACTIVE, SERVICE_DISMISSED } from './constant/constant';

export const useServiceInsights = (
  serviceInsightsDetails: ServiceInsightDetailProps,
  equipmentDetails: Equipment,
  isCspUser: boolean
) => {
  const activeServiceInsight =
    serviceInsightsDetails?.instanceSearchResponse?.filter(
      (instance: InstanceData) =>
        instance.state === SERVICE_ACTIVE &&
        instance.userRelatedState !== SERVICE_DISMISSED
    );

  const isServiceInsightAvailable = useMemo(
    () =>
      activeServiceInsight?.some(
        (instance: InstanceData) =>
          instance.assetId === equipmentDetails.assetId
      ),
    [activeServiceInsight, equipmentDetails]
  );

  return {
    serviceInsightEnabled:
      isCspUser &&
      serviceInsightsDetails.isServiceInsightAvailable &&
      isServiceInsightAvailable
  };
};
